<template>
  <div class="w-full">
    <p
      v-if="packings.length === 0 || !packings"
      class="text-center"
    >
      -
    </p>
    <ul
      v-else
      class="list-disc ml-[16px]"
    >
      <li
        v-for="packing in packings"
        :key="packing.packing_detail_id"
        class="text-left"
      >
        <div class="flex justify-between items-center">
          {{ packing.packing_name || '-' }}
          ({{ packing.layer }})
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    packings: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
}
</script>
